import { render, staticRenderFns } from "./IgCheckoutModal.vue?vue&type=template&id=6afa5c9a&"
import script from "./IgCheckoutModal.vue?vue&type=script&lang=js&"
export * from "./IgCheckoutModal.vue?vue&type=script&lang=js&"
import style0 from "./IgCheckoutModal.vue?vue&type=style&index=0&id=6afa5c9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports